export const useReferrer = () => {
    const setInitialReferrer = () => {
        const origin = window.location.origin;
        if (
            !document.referrer?.includes(origin) &&
            !sessionStorage.getItem('initialReferrer') &&
            sessionStorage.getItem('initialReferrer') !== document.referrer
        ) {
            sessionStorage.setItem('initialReferrer', document.referrer);
        }
    };

    const getInitialReferrer = () => {
        return sessionStorage.getItem('initialReferrer') ? sessionStorage.getItem('initialReferrer') : window.location.origin;
    };

    return { getInitialReferrer, setInitialReferrer };
};
